import authApi from "../../../contextProviders/auth-api";
import { userActions, apiList, methodType } from "../../../contextProviders/constant";

export const BILLING_FREQUENCY = {
  MONTHLY: "Monthly",
  YEARLY: "Yearly",
};

export const TRIAL_PERIOD_DAYS = 60;

export const getErrorMessage = (status, translate) => {
  switch (status) {
    case 403:
      return translate("pricing-error-not-eligible");
    case 409:
      return translate("pricing-error-already-subscribed");
    default:
      return translate("pricing-error-generic");
  }
};

export const getChangePlanErrorMessage = (status, translate) => {
  switch (status) {
    case 404:
      return translate("change-plan-error-no-subscription");
    case 409:
      return translate("change-plan-error-already-on-plan");
    default:
      return translate("pricing-error-generic");
  }
};

export const fetchTrialEligibility = async (tokenhandler) => {
  const response = await authApi({
    url: apiList[userActions.qboConnectionEligibility],
    method: methodType.get,
    tokenhandler,
    isSecured: true,
    headers: { "api-version": "v1" },
  });

  return response?.data?.trial_eligible === true;
};

export const submitPlanSelect = async (selectedPlan, trialEligible, tokenhandler) => {
  const body = {
    billing_frequency: selectedPlan,
  };

  if (trialEligible) {
    body.trial_period_days = TRIAL_PERIOD_DAYS;
  }

  return await authApi({
    url: apiList[userActions.planSelect],
    method: methodType.post,
    body,
    tokenhandler,
    isSecured: true,
  });
};

export const submitChangePlan = async (newFrequency, tokenhandler) => {
  return await authApi({
    url: apiList[userActions.changePlan],
    method: methodType.post,
    body: { billing_frequency: newFrequency },
    tokenhandler,
    isSecured: true,
  });
};

export const getOppositePlan = (currentFrequency) => {
  return currentFrequency === BILLING_FREQUENCY.MONTHLY
    ? BILLING_FREQUENCY.YEARLY
    : BILLING_FREQUENCY.MONTHLY;
};

const helper = {
  BILLING_FREQUENCY,
  TRIAL_PERIOD_DAYS,
  getErrorMessage,
  getChangePlanErrorMessage,
  fetchTrialEligibility,
  submitPlanSelect,
  submitChangePlan,
  getOppositePlan,
};

export default helper;